import React, { useState } from "react";
import "./Suite.css";

export default function Suite() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Custom Metaverse Platform Development-",
      description:
        "Design and development of purpose-built metaverse platforms aligned with business models, user behavior, and scalability requirements.",
    },
    {
      id: 2,
      title: "3D Environment and Virtual World Creation-",
      description:
        "Creation of high-quality 3D spaces, virtual landscapes, and environments that deliver immersive, visually rich user experiences.",
    },
    {
      id: 3,
      title: "AR/VR and XR Integration-",
      description:
        "Integration of augmented, virtual, and extended reality technologies to enable realistic interactions across devices and immersive hardware.",
    },
    {
      id: 4,
      title: "Blockchain and NFT Integration-",
      description:
        "Implementation of blockchain infrastructure to support digital ownership, NFTs, secure transactions, and decentralized economies.",
    },
    {
      id: 5,
      title: "Real-Time Interaction and Multiplayer Systems-",
      description:
        "Development of real-time communication, avatar interaction, and multiplayer functionality for dynamic and social virtual experiences.",
    },
    {
      id: 6,
      title: "Cross-Platform Accessibility-",
      description:
        "Support for web, mobile, and VR devices to ensure consistent access and seamless experiences across multiple platforms.",
    },
  ];

  return (
    <div id="metaverse-suite" className="metaversemainclass">
      <h2 className="heading">
       End-to-End Metaverse Development Services
      </h2>
      <p className="subheading">
       Metaverse development services enable immersive, scalable virtual environments designed for performance, interaction, and long-term growth.
      </p>

      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
